export const DEFAULT_BLOCKED_PATH = "/blocked";
